/**
 * Map a react-select value (option object or primitive id) onto the current
 * options list. String-compares ids so number/string mismatches still display.
 */
export function resolveSelectValue(selected, options = [], isMulti = false) {
  const list = Array.isArray(options) ? options : [];

  const matchOne = (val) => {
    if (val == null || val === "") return null;
    if (typeof val === "object") {
      if (!("value" in val) || val.value == null || val.value === "") {
        return null;
      }
      const matched = list.find(
        (opt) => opt != null && String(opt.value) === String(val.value)
      );
      return matched ?? val;
    }
    return (
      list.find((opt) => opt != null && String(opt.value) === String(val)) ??
      null
    );
  };

  if (isMulti) {
    if (!Array.isArray(selected)) return [];
    return selected.map(matchOne).filter(Boolean);
  }

  return matchOne(selected);
}

export function idsMatch(a, b) {
  if (a == null || a === "" || b == null || b === "") return false;
  return String(a) === String(b);
}
